<template>
    <section class="general-modal">
        <h1 class="modal-title">Politique de confidentialité </h1>
        <p>Testachats œuvre depuis de nombreuses années pour la défense des droits des consommateurs, en reconnaissant toujours l’importance de protéger la vie privée et les données à caractère personnel.
            Vous trouverez donc, dans cette note d’information, tous les éléments nécessaires à une meilleure compréhension du traitement de vos données à caractère personnel.
        </p>
        <p>Ce document étant susceptible d’être mis à jour et/ou modifié à l’avenir, nous vous recommandons de le lire régulièrement.</p>

        <h2>1. Responsables conjoints du traitement</h2>

        <p><strong>L’Associations Belge , des Consommateurs Testachats ASBL</strong> ASBLassociation sans but lucratif, inscrite à la Banque Carrefour des entreprises sous le numéro 0407.703.668, et la société coopérative <strong>Association des Consommateurs Testachats SC</strong> , inscrite au registre de la Banque Carrefour des Entreprises sous le numéro BE 0425.989.356, sont les responsables conjoints du traitement de vos données à caractère personnel. Dans la suite de cette politique de confidentialité, elles seront désignées par  «<strong>les Responsables conjoints du traitement</strong>» ou « <strong>Testachats </strong>».</p>

        <p>Elles ont toutes deux leur siège social à 1060 Bruxelles (Saint Gilles), rue de Hollande n° 13. Vous pouvez les contacter par email à l’adresse <a href="mailto:privacy@test-achats.be">privacy@test-achats.be</a>.</p>
        <p>Les Responsables conjoints du traitement ont conclu un accord conformément à l’art. 26 du RGPD par lequel ils se sont engagés, entre autres choses, à :</p>
        <ul>
            <li>déterminer conjointement les finalités et les moyens du traitement de vos données à caractère personnel ;</li>
            <li>déterminer conjointement une procédure afin de vous apporter une réponse en temps voulu au cas où vous souhaiteriez exercer vos droits conformément aux articles 15 et suivants du RGPD ;</li>
            <li>définir conjointement ces informations sur le respect de la vie privée.</li>
        </ul>

        <h2>2. Délégué à la protection des données (DPO)</h2>
        <p>Les Responsables conjoints du traitement ont désigné chacun de leur côté, conformément à l’art. 37 du RGPD, un Délégué à la protection des données (en anglais, data protection officer, ci-après « DPO ») que vous pouvez contacter à l’adresse suivante :
            <a href="mailto:teamprivacy@test-achats.be">teamprivacy@test-achats.be</a>.</p>

        <h2>3. Finalité et base légale du traitement des données à caractère personnel</h2>
        <p>Si vous n'êtes pas encore membre, abonné ou supporter de Testachats, vos coordonnées peuvent être utilisées à des fins de marketing direct. Le télémarketing se fait, conformément à l’article VI.112 du code de droit économique, après vérification qu’il n’y a pas d’opposition reprise sur la liste « ne m’appelez plus » (<a href="https://www.dncm.be" target="_blank">www.dncm.be</a>). Les informations sur la manière dont Testachats a obtenu vos données peuvent toujours être demandées par email à l’adresse
            <a href="mailto:privacy@test-achats.be">privacy@test-achats.be</a> ou en nous contactant par téléphone au numéro <a href="tel:02 542 33 00">02 542 33 00</a>.</p>
        <p>Le tableau ci-après reprend une vue d’ensemble des différentes catégories de données à caractère personnel que nous traitons, les finalités s’y rapportant et la base légale du traitement.</p>
        <p>Veuillez noter que mis à part les finalités indiquées ci-après, nous traiterons toujours vos données de manière à gérer la relation contractuelle qui nous unit et, sauf si vous vous y opposez, à vous envoyer des informations promotionnelles concernant nos services. Vous pouvez vous opposez à ces communications promotionnelles en cochant l’espace prévu à cet effet au bas du formulaire d’enregistrement sur notre site ou en adaptant votre consentement dans votre espace personnel sur notre site internet.</p>
        <p>Les achats groupés, les pétitions publiques, l’utilisation de notre module de dépôt et de gestion de plaintes (« poke a company ») et les autres initiatives faisant partie de la mission de Testachats peuvent, si nécessaire, faire l’objet d’un complément d’information sur le traitement de vos données dans le cadre de ces services spécifiques. Dans pareil cas, les informations complémentaires vous seront communiquées sur la page internet spécifique de ces services. Ces informations complémentaires seront considérées comme avenant à la présente Politique de confidentialité. En cas de contradiction, les règles spéciales auront la préséance sur les règles générales contenues dans la présente Politique de confidentialité.</p>
        <p>Il est possible que les finalités énumérées ici ne s’appliquent pas toutes à votre cas spécifique, mais nous vous indiquons tous les scénarios possibles au cas où vous décideriez de
            profiter de l’ensemble des services que Testachats vous propose.</p>
        <p>Sachez que les exemples sont donnés à titre purement indicatifs et ne sont pas exhaustifs.</p>
<p>La communication des données à caractère personnel marquées d’un astérisque (*) sur internet est obligatoire. En l’absence de ces données, nous ne serons pas en mesure de vous fournir le service demandé.</p>


        <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
               style='border-collapse:collapse;mso-yfti-tbllook:1184'>
            <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Données
  d’identification (nom, prénom, date de naissance) et données de contact
  (e-mail, numéro de téléphone, adresse), numéro d’abonné, nom d’utilisateur et
  mot de passe sur le site internet.<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:1'>
                <td style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Finalité<o:p></o:p></span></p>
                </td>
                <td style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Base légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:2'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Inscription en
  tant que Supporter ou Abonné sur le site internet de Testachats ou sur des
  sites ou pages web liées à Testachats.<o:p></o:p></span></p>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>&nbsp;<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles : en vous inscrivant sur notre
  site internet, vous acceptez d’utiliser nos services dans les conditions
  suivantes:&nbsp;<a href="https://www.test-achats.be/info/conditions-generales"
                     target="_blank">conditions générales</a><o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:3'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Adhésion à
  l’Association Testachats et abonnement à un ou plusieurs de nos magazines ou
  services<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:4'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gestion de vos
  abonnements (exemple : envois, remboursements), traitement de demandes s’y
  rapportant<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles ; respect d’une obligation légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:5'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Traitement des
  plaintes et réclamations à l’égard de Testachats et prévention des cas de
  fraude contre Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  à protéger les intérêts des Responsables conjoints du traitement ; respect
  d’une obligation légale (exemple : droit pénal)<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:6'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation à
  des Pétitions, des Achats groupés et autres actions proposées par Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles ; respect d’une obligation légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:7'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation à un
  projet ou une action financé(e) par des fonds publics belges ou
  européens&nbsp;<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement ou
  obligation légale contenue dans l’acte d’adjudication du projet subsidié<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:8'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation à
  un événement (par exemple, séminaires, cours et autres) organisé par Test
  Achats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement ou
  intérêt légitime à interagir avec les participants, exécution d’obligations
  contractuelles ; respect d’une obligation légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:9'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Fourniture de
  conseils juridiques, fiscaux ou autres par téléphone, e-mail ou courrier<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de mesures
  contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:10'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation
  volontaire des personnes sélectionnées pour à nos tests de produits et/ou
  services<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:11'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Envoi de cadeaux,
  guides promotionnels ou autres produits gratuits<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution d’un
  contrat ou intérêt légitime à améliorer la fidélité des consommateurs<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:12'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Utilisation de
  nos comparateurs, simulateurs<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:13'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Informations sur
  les combats, les résultats obtenus et les prochains objectifs de Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  à promouvoir nos valeurs autant que possible<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:14'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Enquêtes de
  satisfaction des consommateurs dans le cadre de produits et/ou services avec
  publication simultanée d’articles dans nos magazines<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  à défendre nos valeurs de protection des consommateurs et à améliorer la
  manière dont nous le faisons<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:15'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Statistiques
  fondées sur votre utilisation de nos produits ou services<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement ou
  intérêt légitime à améliorer notre offre<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:16'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Informations sur
  les meilleurs prix, réductions et opportunités négociés par Testachats pour
  faciliter vos achats (marketing direct)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  (voyez le point 3.2); consentement, si la loi l’exige<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:17'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Promotion des
  magazines, guides et abonnements proposés par Testachats (marketing direct)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  (voyez le point 3.2) ; consentement si la loi l’exige<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:18'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Les informations
  sur les services que vous utilisez, les centres d’intérêts que vous
  déclarez&nbsp;dans l’utilisation de nos sites internet ou dans vos
  communications avec Testachats<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:19'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Cela nous permet
  de moduler/sélectionner les informations et services susceptibles de vous
  intéresser.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Nécessaire pour
  l’exécution du contrat, consentement via les cookies ou intérêt légitime,
  aussi longtemps que vous ne vous opposez pas à ce traitement<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:20'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Emails, lettres,
  contrats, bons de commande, relatifs à un différent<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:21'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Lorsque vous
  faites appel à notre service d’aide individuelle, ces données sont
  nécessaires pour fournir une réponse à votre question. Ces données ne sont
  pas utilisée pour autre chose que pour répondre à votre demande.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Nécessaire pour
  l’exécution du contrat, consentement via les cookies, intérêt légitime.<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:22'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Portrait, photos,
  vidéos, fichiers audio<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:23'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>En cas de
  participation volontaire à des interviews ou études se rapportant à des
  articles à paraître dans nos magazines<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:24'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Données bancaires
  (exemple : code IBAN ou carte de crédit)<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:25'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Facturation du
  prix des achats, services ou abonnements souscrits auprès de Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:26'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Catégories
  particulières de données : données sur la santé<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:27'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consultations par
  téléphone ou e-mail pour des plaintes relatives à des problèmes ou
  disfonctionnements dans le secteur médical; ou à des problèmes de santé.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement<o:p></o:p></span></p>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>&nbsp;<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:28'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Données
  d’identification (nom, prénom, date de naissance) et données de contact
  (e-mail, numéro de téléphone, adresse), numéro d’abonné, nom d’utilisateur et
  mot de passe sur le site internet.<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:29'>
                <td style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Finalité<o:p></o:p></span></p>
                </td>
                <td style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Base légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:30'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Inscription en
  tant que Supporter ou Abonné sur le site internet de Testachats ou sur des
  sites ou pages web liées à Testachats.<o:p></o:p></span></p>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>&nbsp;<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles : en vous inscrivant sur notre
  site internet, vous acceptez d’utiliser nos services dans les conditions
  suivantes:&nbsp;</span><a
                        href="https://www.test-achats.be/info/conditions-generales" target="_blank"><span
                        style='font-family:"Lato",sans-serif;mso-fareast-font-family:"Times New Roman";
  mso-bidi-font-family:"Times New Roman";color:#0086CE;mso-fareast-language:
  EN-GB'>conditions générales</span></a><span style='font-family:"Lato",sans-serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
  color:#4A4A4A;mso-fareast-language:EN-GB'><o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:31'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Adhésion à
  l’Association Testachats et abonnement à un ou plusieurs de nos magazines ou
  services<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:32'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Gestion de vos
  abonnements (exemple : envois, remboursements), traitement de demandes s’y
  rapportant<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles ; respect d’une obligation légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:33'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Traitement des
  plaintes et réclamations à l’égard de Testachats et prévention des cas de
  fraude contre Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  à protéger les intérêts des Responsables conjoints du traitement ; respect
  d’une obligation légale (exemple : droit pénal)<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:34'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation à
  des Pétitions, des Achats groupés et autres actions proposées par Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles ; respect d’une obligation légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:35'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal><span style='font-family:"Times New Roman",serif;
  mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-GB'>Participation
  à un projet ou une action financé(e) par des fonds publics belges ou
  européens&nbsp;<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal><span style='font-family:"Times New Roman",serif;
  mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-GB'>Consentement
  ou obligation légale contenue dans l’acte d’adjudication du projet subsidié<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:36'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation à
  un événement (par exemple, séminaires, cours et autres) organisé par Test
  Achats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement ou
  intérêt légitime à interagir avec les participants, exécution d’obligations
  contractuelles ; respect d’une obligation légale<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:37'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Fourniture de
  conseils juridiques, fiscaux ou autres par téléphone, e-mail ou courrier<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de mesures
  contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:38'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Participation
  volontaire des personnes sélectionnées pour à nos tests de produits et/ou
  services<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:39'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Envoi de cadeaux,
  guides promotionnels ou autres produits gratuits<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution d’un
  contrat ou intérêt légitime à améliorer la fidélité des consommateurs<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:40'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Utilisation de
  nos comparateurs, simulateurs<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:41'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Informations sur
  les combats, les résultats obtenus et les prochains objectifs de Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  à promouvoir nos valeurs autant que possible<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:42'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Enquêtes de
  satisfaction des consommateurs dans le cadre de produits et/ou services avec
  publication simultanée d’articles dans nos magazines<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  à défendre nos valeurs de protection des consommateurs et à améliorer la
  manière dont nous le faisons<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:43'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Statistiques
  fondées sur votre utilisation de nos produits ou services<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement ou
  intérêt légitime à améliorer notre offre<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:44'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Informations sur
  les meilleurs prix, réductions et opportunités négociés par Testachats pour
  faciliter vos achats (marketing direct)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  (voyez le point 3.2); consentement, si la loi l’exige<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:45'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Promotion des
  magazines, guides et abonnements proposés par Testachats (marketing direct)<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Intérêt légitime
  (voyez le point 3.2) ; consentement si la loi l’exige<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:46'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Les informations
  sur les services que vous utilisez, les centres d’intérêts que vous
  déclarez&nbsp;dans l’utilisation de nos sites internet ou dans vos
  communications avec Testachats<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:47'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Cela nous permet
  de moduler/sélectionner les informations et services susceptibles de vous
  intéresser.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Nécessaire pour
  l’exécution du contrat, consentement via les cookies ou intérêt légitime,
  aussi longtemps que vous ne vous opposez pas à ce traitement<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:48'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Emails, lettres,
  contrats, bons de commande, relatifs à un différent<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:49'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Lorsque vous
  faites appel à notre service d’aide individuelle, ces données sont
  nécessaires pour fournir une réponse à votre question. Ces données ne sont
  pas utilisée pour autre chose que pour répondre à votre demande.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Nécessaire pour
  l’exécution du contrat, consentement via les cookies, intérêt légitime.<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:50'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Portrait, photos,
  vidéos, fichiers audio<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:51'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>En cas de
  participation volontaire à des interviews ou études se rapportant à des
  articles à paraître dans nos magazines<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:52'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Données bancaires
  (exemple : code IBAN ou carte de crédit)<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:53'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Facturation du
  prix des achats, services ou abonnements souscrits auprès de Testachats<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Exécution de
  mesures contractuelles ou précontractuelles<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:54'>
                <td colspan=2 style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Catégories
  particulières de données : données sur la santé<o:p></o:p></span></p>
                </td>
            </tr>
            <tr style='mso-yfti-irow:55;mso-yfti-lastrow:yes'>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consultations par
  téléphone ou e-mail pour des plaintes relatives à des problèmes ou
  disfonctionnements dans le secteur médical; ou à des problèmes de santé.<o:p></o:p></span></p>
                </td>
                <td valign=top style='padding:.75pt .75pt .75pt .75pt'>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>Consentement<o:p></o:p></span></p>
                    <p class=MsoNormal style='mso-margin-bottom-alt:auto'><span style='font-family:
  "Lato",sans-serif;mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:
  "Times New Roman";color:#4A4A4A;mso-fareast-language:EN-GB'>&nbsp;<o:p></o:p></span></p>
                </td>
            </tr>
        </table>


        <p>3.2 Dans le cadre du contrat de Supporter qui vous lie à Testachats, vous acceptez de recevoir des information et des promotions sur ses activités. Si vous n’êtes pas supporter de Testachats mais que vous avez été abonné de Testachats, Testachats peut, sur base de son intérêt légitime et pendant une période raisonnable, vous recontacter pour vous reproposer ses services. Vos données ne sont pas communiquées à des tiers à des fins de marketing et vous avez le droit de refuser les communications commerciales de Testachats à la réception de chaque message en cliquant sur l’hyperlien « désabonnement » ou à tout moment par email adressé à
            <a href="mailto:privacy@test-achats.be">privacy@test-achats.be</a> ou en vous rendant sur votre page personnelle sur le site de Testachats: <a href="https://www.test-achats.be/moncompte/personal-information" target="_blank">www.test-achats.be/moncompte/personal-information</a>.</p>

        <h2>4. Partage de données à caractère personnel</h2>
        <p>4.1 Afin d’exécuter correctement toutes les activités de traitement nécessaires aux finalités conformément à l’art. 3 des présentes informations, vos données à caractère personnel pourront aussi être traitées par les parties suivantes :</p>

        <ul>
            <li>•	parties tierces exécutant, sur base d’un contrat avec Testachats, une partie des activités de traitement des données.</li>
            <li>Dans pareil cas, conformément à l’article 28 du RGPD, ces parties sont des sous-traitants qui ne peuvent traiter vos données pour leur propre usage ;
            </li>
            <li>•	les individus, employés et/ou collaborateurs de Testachats chargés d’activités de traitement spécifiques et/ou supplémentaires sur vos données à caractère personnel et ayant
                été désignés comme « Personnes autorisées » conformément à l’art. 29 du RGPD ;</li>
            <li>•	Vos données à caractère personnel peuvent être communiquées à des organes publics ou aux autorités judiciaires si cela est requis par la loi ou pour empêcher ou punir un délit.</li>
        </ul>
        <p>Conformément à l’art. 4, point 9) du RGPD, « les autorités publiques qui sont susceptibles de recevoir communication de données à caractère personnel dans le cadre d’une mission d’enquête particulière conformément au droit de l’Union ou au droit d’un État membre ».</p>
        <p>Si la finalité du traitement comprend la collaboration avec des tiers - comme pour des achats groupés, des achats avec réduction de prix pour les abonnés ou des pétitions -, toutes les données nécessaires aux parties tierces pour fournir le service leur seront communiquées ; Des informations spécifiques seront fournies dans le cadre précis de chacune de ces actions ;</p>

        <p>4.2 Veuillez noter que Testachats ou les sous-traitants peuvent faire appel aux services fournis par des sociétés pouvant conserver vos données en dehors de l’Espace économique européen. Nous nous assurons toujours dans ce cas que ces sociétés soient couvertes par une décision d’adéquation de la Commission européenne.</p>

        <p>4.3 En de rares occasions, Testachats peut être tenu de transmettre vos données à caractère personnel à une autorité publique dans l’exercice de ses fonctions, en vertu d’un mandat ou décision judiciaire ou d’une disposition légale. Sauf si ce n’est pas permis, Testachats veillera, si c’est raisonnablement possible, à vous en informer au préalable.</p>

        <h2>5. Conservation de données à caractère personnel</h2>
        <p>5.1 Sauf demande d’annulation de votre part, les Responsables conjoints du traitement conserveront vos données à caractère personnel pendant toute la durée de votre inscription sur le site internet de Testachats.</p>

        <p>5.2 Si vous êtes aussi abonné aux magazines de Testachats, nous conserverons vos données à caractère personnel pendant une période légale ne pouvant dépasser 10 ans  à compter de la date de résiliation de votre abonnement.</p>

        <p>5.3 Rappelez-vous que vous êtes à la fois abonné (avec l’abonnement à nos magazines et autres) et Supporter. Si vous décidez de résilier uniquement votre abonnement, sachez alors que vous pourrez conserver gratuitement votre statut de Supporter.</p>
        <p>Sauf demande explicite de résiliation de l’ensemble de vos contrats (à la fois en tant qu’Abonné et « Supporter »), vous pourrez par conséquent continuer à utiliser les services proposés directement sur notre site. Si vous renoncez donc uniquement à votre statut d’Abonné, notez que toutes les données concernant le statut de « Supporter » seront conservées et que vous continuerez à recevoir nos communications comme défini dans vos préférences, même si vous annulez votre abonnement à nos magazines.</p>

        <p>5.4 Après annulation, nous pourrons également conserver vos données absolument nécessaires pour prouver que nous nous conformons aux lois et règlements applicables comme le RGPD, le droit fiscal, la loi sur la vente à distance, etc.
            Dans ce cas, nous ne conserverons que les données absolument nécessaires à cette fin et elles seront conservées de manière bloquée, dûment pseudonymisées, et uniquement pendant le délai de prescription pouvant varier en fonction du droit applicable.
        </p>
        <p>Si la spécificité d’une action en particulier organisée par Testachats demande des périodes de conservation différentes, cela sera indiqué dans les conditions ou la politique de confidentialité spécifiques pour l’action, sur la page internet spécifique.</p>

        <h2>6. Droits de la personne concernée</h2>
        <p>6.1 Vous pouvez exercer vos droits dans le cadre du RGPD (accès à vos données, rectification ou effacement de celles-ci, opposition à l’utilisation de vos données pour du marketing ou à toute utilisation de celles-ci) en contactant notre service privacy à l’adresse
            <a href="mailto:privacy@test-achats.be">privacy@test-achats.be</a>.</p>
        <p>Vous pouvez également utiliser cette adresse mail pour toute plainte ou demande d’information.</p>
        <p>Si vous estimez qu’un de vos droits de protection de vos données à caractère personnel a été enfreint, vous avez le droit d’adresser une plainte à l’Autorité de Protections des Données, Rue de la Presse 35, à 1000 Bruxelles, par courrier, par email à contact(at)apd-gba.be ou en vous rendant sur la page de contact de l’Autorité : https://www.autoriteprotectiondonnees.be/contact.</p>

        <p>6.2 Vous pouvez aussi exercer certains de vos droits dans votre Espace personnel sur le site internet de Testachats : <a href="https://www.test-achats.be/moncompte/personal-information" target="_blank">www.test-achats.be/moncompte/personal-information</a></p>

        <p>6.3 N’hésitez pas à nous téléphoner au 02 542 33 00 lorsque vous avez un doute ou un problème avec l’exercice de vos droits.</p>

        <p>6.4 Chaque fois que vos données sont traitées en vertu de votre consentement (voir tableau ci-avant), vous pouvez retirer votre consentement à tout moment, sans nuire à la légalité du traitement en vertu de votre consentement avant son retrait ;</p>

        <p>6.5 Pour répondre à vos demandes, si les informations communiquées par vos soins ne sont pas suffisantes pour vous identifier avec certitude, nous pourrons vous demander des informations supplémentaires pour prouver votre identité conformément à l’art. 11 du RGDP. Tenant compte des risques de fuites de données, nous veillerons en particulier à ce que votre identité soit certaine avant de communiquer une copie des données dont nous disposons à votre sujet. Une copie du recto de votre carte d’identité, sur laquelle vous pouvez biffer le numéro de carte d’identité et la date de naissance, pourra vous être demandée.</p>

        <h2>7. Sécurité</h2>
        <p>Testachats met en œuvre et applique des politiques techniques et organisationnelles ainsi que des mesures de sécurité appropriées pour garantir un traitement sûr des données à caractère personnel.
            Ces mesures comprennent par exemple la conclusion d’accords de confidentialité avec nos collaborateurs et sous-traitants ; la limitation de l’accès aux données à caractère personnel ; la destruction ou l’anonymisation de données à caractère personnel si celles-ci ne sont plus nécessaires pour les finalités pour lesquelles elles ont été collectées.
        </p>

        <p>La sécurité des informations dépendant en partie de la sécurité de l’ordinateur ou appareil que vous utilisez pour communiquer avec nous, ainsi que de la manière dont vous protégez vos noms d’utilisateur et mots de passe, veuillez prendre les mesures appropriées pour protéger ces informations.</p>


    </section>
</template>

<script>
export default {
    name: "PrivacyModal"
}
</script>

<style scoped>

</style>
